import { render, staticRenderFns } from "./new.vue?vue&type=template&id=47205190&scoped=true&lang=pug&"
import script from "./new.vue?vue&type=script&setup=true&lang=js&"
export * from "./new.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./new.vue?vue&type=style&index=0&id=47205190&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47205190",
  null
  
)

export default component.exports